import { configureStore } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'
import { combineReducers } from 'redux'
import { persistReducer } from 'redux-persist'
import thunk from 'redux-thunk'

import globalErrorReducer from './globalError'
import deviceInfoReducer from './deviceInfo'
import urlInfoReducer from './urlInfo'

const reducers = combineReducers({
	globalError: globalErrorReducer,
	deviceInfo: deviceInfoReducer,
	urlInfo: urlInfoReducer,
})

const persistConfig = {
	key: 'root',
	storage,
}

const persistReducers = persistReducer(persistConfig, reducers)

const store = configureStore({
	reducer: persistReducers,
	devTools: process.env.NODE_ENV !== 'production',
	middleware: [thunk],
})

export default store
